import ListSelector from './ListSelector'
import $ from 'jquery'
import messageResource from '../messageResource'
import {StaffPerformanceColumnsConfig} from 'constants'
import {Feature, isEnabled} from '../features'

export default function StaffoutputColumnsFormatSelector(){}

StaffoutputColumnsFormatSelector.prototype.init = function(id, initValue, onChangeCallback){
    this.selector = new ListSelector({
        renderTo: $.find("#" + id)[0],
        menuCls: "columnsFormatMenu",
        ctCls : " i"
    });

    const preText = messageResource.getMessage("report.show") + "&nbsp";
    this.selector.addItems([
        {
            text: preText + messageResource.getEscapedMessage("report.staffoutput.configure_columns.user_no_format"),
            value: StaffPerformanceColumnsConfig.USERS_ONLY
        }]);
    if (isEnabled(Feature.UGR) ||
        initValue === StaffPerformanceColumnsConfig.GROUPS_ONLY ||
        initValue === StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITHOUT_SUBTOTALS ||
        initValue === StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITH_SUBTOTALS)
    {
        this.selector.addSeparator();
        this.selector.addItems([{
            text: preText + messageResource.getEscapedMessage("report.staffoutput.configure_columns.user_group_no_format"),
            value: StaffPerformanceColumnsConfig.GROUPS_ONLY
        },
                                   {
                                       text: preText + messageResource.getEscapedMessage("report.staffoutput.configure_columns.user_group_user_no_format"),
                                       value: StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITHOUT_SUBTOTALS
                                   },
                                   {
                                       text: preText + messageResource.getEscapedMessage(
                                               "report.staffoutput.configure_columns.user_group_user_with_subtotal_no_format"),
                                       value: StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITH_SUBTOTALS
                                   }
                               ]);
    }
    if (isEnabled(Feature.TZG) ||
        initValue === StaffPerformanceColumnsConfig.TZ_GROUPS_ONLY ||
        initValue === StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITH_SUBTOTALS ||
        initValue === StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITHOUT_SUBTOTALS)
    {
        this.selector.addSeparator();
        this.selector.addItems([
                                   {
                                       text: preText + messageResource.getEscapedMessage("report.staffoutput.configure_columns.time_zone_group_no_format"),
                                       value: StaffPerformanceColumnsConfig.TZ_GROUPS_ONLY
                                   },
                                   {
                                       text: preText + messageResource.getEscapedMessage("report.staffoutput.configure_columns.time_zone_group_user_no_format"),
                                       value: StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITHOUT_SUBTOTALS
                                   },
                                   {
                                       text: preText + messageResource.getEscapedMessage(
                                               "report.staffoutput.configure_columns.time_zone_groups_user_with_subtotal_no_format"),
                                       value: StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITH_SUBTOTALS
                                   }
                               ]);

    }

    this.selector.on("change", onChangeCallback );
    this.selector.setActiveItemByValue(initValue, true);
    return this;
};

StaffoutputColumnsFormatSelector.prototype.getValue = function(){
    return this.selector.getSelectedItem().value;
};

StaffoutputColumnsFormatSelector.prototype.setActiveItemByValue = function( value , suppressChangeEvent) {
    this.selector.setActiveItemByValue(value, suppressChangeEvent);
};


// WEBPACK FOOTER //
// ./web/js/controls/StaffoutputColumnsFormatSelector.js